module.exports = __webpack_public_path__ + "static/media/welcome.1ca3859d.png";